"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROXY_MIXIN_CLASS_KEY = void 0;
exports._createMixinProxy = _createMixinProxy;
exports.freeze = freeze;
exports._createFreezeProxy = _createFreezeProxy;
exports._toDoc = _toDoc;
exports._mixinClass = _mixinClass;
const platform_1 = require("@hcengineering/platform");
const PROXY_TARGET_KEY = '$___proxy_target';
exports.PROXY_MIXIN_CLASS_KEY = '$__mixin';
/**
 * @internal
 */
function _createMixinProxy(mixin, ancestorProxy) {
    return {
        get(target, property, receiver) {
            if (property === PROXY_TARGET_KEY) {
                return target;
            }
            // We need to override _class property, to return proper mixin class.
            if (property === exports.PROXY_MIXIN_CLASS_KEY) {
                return mixin._id;
            }
            const value = target[mixin._id]?.[property];
            if (value === undefined) {
                return ancestorProxy !== null ? ancestorProxy.get?.(target, property, receiver) : target[property];
            }
            return value;
        }
    };
}
function freeze(value) {
    if (value != null && typeof value === 'object') {
        if (Array.isArray(value)) {
            return value.map((it) => freeze(it));
        }
        if (value instanceof Map) {
            throw new platform_1.PlatformError((0, platform_1.unknownError)('Map is not allowed in model'));
        }
        if (value instanceof Set) {
            throw new platform_1.PlatformError((0, platform_1.unknownError)('Set is not allowed in model'));
        }
        return new Proxy(value, _createFreezeProxy(value));
    }
    return value;
}
/**
 * @internal
 */
function _createFreezeProxy(doc) {
    return {
        get(target, property, receiver) {
            const value = target[property];
            return freeze(value);
        },
        set(target, p, newValue, receiver) {
            throw new platform_1.PlatformError((0, platform_1.unknownError)('Modification is not allowed'));
        },
        defineProperty(target, property, attributes) {
            throw new platform_1.PlatformError((0, platform_1.unknownError)('Modification is not allowed'));
        },
        deleteProperty(target, p) {
            throw new platform_1.PlatformError((0, platform_1.unknownError)('Modification is not allowed'));
        },
        setPrototypeOf(target, v) {
            throw new platform_1.PlatformError((0, platform_1.unknownError)('Modification is not allowed'));
        }
    };
}
/**
 * @internal
 */
function _toDoc(doc) {
    const targetDoc = doc[PROXY_TARGET_KEY];
    if (targetDoc !== undefined) {
        return targetDoc;
    }
    return doc;
}
/**
 * @internal
 */
function _mixinClass(doc) {
    return doc[exports.PROXY_MIXIN_CLASS_KEY];
}
//# sourceMappingURL=proxy.js.map